import { render, staticRenderFns } from "./MvPageBottomProgress.vue?vue&type=template&id=827dacb0&"
import script from "./MvPageBottomProgress.vue?vue&type=script&lang=js&"
export * from "./MvPageBottomProgress.vue?vue&type=script&lang=js&"
import style0 from "./MvPageBottomProgress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VProgressLinear})
